<div>
    <div class="dropdown dropdown-inline ms-2" data-toggle="tooltip" title="{{ lblAddNewItem }}" data-placement="left"
        placement="bottom-right" ngbDropdown>
        <a style="position: relative; top: 9px" *ngIf="ConnectorChildrenList?.length > 1"
            class="btn primary-ebtn font-weight-bold py-3 px-6" aria-haspopup="true" aria-expanded="false"
            ngbDropdownToggle>
            <span>{{ lblAdd }}</span>
        </a>
        <a style="position: relative; top: 9px" *ngIf="ConnectorChildrenList?.length == 1"
            class="btn primary-ebtn font-weight-bold py-3 px-6" aria-haspopup="true" aria-expanded="false"
            (click)="open(ConnectorChildrenList[0])">
            <span>{{ lblAdd }}</span>
        </a>
        <div class="dropdown-menu p-0 m-0 dropdown-menu-md dropdown-menu-right" ngbDropdownMenu>
            <ul class="navi navi-hover py-5">
                <li class="navi-item" *ngFor="let type of ConnectorChildrenList">
                    <a class="navi-link cursor-pointer" (click)="open(type)">
                        <span class="navi-text" style="margin-left: 10px">{{ type.taggedItemType }}</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>